import capitalize from "lodash/capitalize";

export const EMPLOYMENT_TYPE_1099 = "1099";

// Hours a worker must log to accrue 1 hr of PTO, or null when the policy does
// not accrue per-hour (rate of 0, null, or undefined). Guards the 1/rate divide
// that otherwise renders to the worker as "Infinity"/"NaN" hours.
export const hoursPerAccruedHour = (rate) => {
  const hours = 1 / rate;
  return Number.isFinite(hours) && hours > 0 ? hours : null;
};

export const codeDisplay = (code) => {
  switch (code) {
    case "unified":
      return "PTO";
    case "california_covid":
      return "COVID";
    case "california_covid_additional":
      return "COVID (additional)";
    case "work_from_home_tracking":
      return "Work From Home";
    default:
      return capitalize(code);
  }
};
